import React from 'react'
import './styles/Footer.css'

export default function Footer() {
  return (
    <div>
        <h4>Todos os direitos reservados.</h4>
    </div>
  )
}
